export default {
  eyebrow: 'Portal partnera',
  title: 'Kalkulator opłaty serwisowej',
  description: 'Oszacuj przychód z opłaty serwisowej generowany przez restauracje w ramach Twojego konta partnera.',
  toasts: {
    load_error: 'Nie udało się wczytać ustawień opłaty serwisowej.',
  },
};
